import styled from 'styled-components'
import { black, disabledGrey, white, purpley } from 'tcp-common/lib/colors'
import Flex from 'tcp-common/lib/components/Flex'
import { greyBackgroundGradient } from 'tcp-common/lib/gradient'

export const MainWrapper = styled(Flex)`
background-color: ${black};
padding-bottom: 32px;
justify-content: center;
align-items:center;

@media (min-width: 768px) {
    margin: 0 auto; 
    
}
`
export const MainContent = styled(Flex)`
width:100%;
max-width: 100%;
margin-bottom: 40px;
@media (min-width: 768px) {
    margin: 64px auto; 
    max-width: 1024px;
    padding: 0 16px;
    
}
`
export const DetailsContent = styled(Flex)`
background: ${greyBackgroundGradient};border-radius: 0px 0px 20px 20px;
@media (max-width: 768px) {
}
`
export const RightContent = styled(Flex)`
margin: 64px 150px 64px 0
`
export const FAQHeader = styled.h2`
font-weight: 600;
font-size: 40px;
line-height: 48px;
color: ${purpley};
@media (max-width: 768px) {
    color: ${white};
    padding: 32px 16px 16px;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
}
`
export const MidHR = styled.div`
height: 0;
opacity: 0.6;
border-top: 2px solid ${disabledGrey};
margin: 26px 0;
@media screen and (max-width: 768px) {
    margin: 10px 16px 26px;
}
`
export const AccordianView = styled.div`
@media screen and (max-width: 768px) {
    margin: 0 16px;
}
`